var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_has.js
// module id = 18
// module chunks = 6